import { render } from "./LatencyChart.vue?vue&type=template&id=7bd1384a&scoped=true"
import script from "./LatencyChart.vue?vue&type=script&lang=js"
export * from "./LatencyChart.vue?vue&type=script&lang=js"

import "./LatencyChart.vue?vue&type=style&index=0&id=7bd1384a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd1384a"]])

export default __exports__